module.exports = __webpack_public_path__ + "assets/certificate_pdf/20220812175218Certificate.2dce7bb9.pdf";